module.exports = __webpack_public_path__ + "img/landscape.625e6376.jpg";